import { NativeSelect, Box } from '@chakra-ui/react';
import { CellProps, BaseCellOptionProps } from '../types/Cell';

export type SelectCellProps = BaseCellOptionProps & {
  value?: string;
  onChange?: (value: string) => void;
  options: Array<{ value: string; label: string }>;
  isDisabled?: boolean;
};

export const SelectCell = (props: CellProps | SelectCellProps): JSX.Element | null => {
  const { label, value, onChange, options, isDisabled } = props as SelectCellProps;

  if (!options || options.length === 0) {
    return null;
  }

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <Box p="0 10px 0 0">
      <NativeSelect.Root disabled={isDisabled}>
        <NativeSelect.Field
          value={value || label}
          onChange={handleChange}
          bg="background.primary"
          border="default"
          borderColor="border.accent"
          textStyle="body.s.regular"
          color="text.primary"
          h="auto"
          minW="100px"
          minH="28px"
          borderRadius="5px"
          fontSize="14px"
          fontWeight="regular"
          lineHeight="1.3"
          pl="7px"
          pr="25px"
          py="5px"
        >
          {options.map((option) => (
            <option value={option.value} key={option.value}>
              {option.label}
            </option>
          ))}
        </NativeSelect.Field>
        <NativeSelect.Indicator />
      </NativeSelect.Root>
    </Box>
  );
};
